export function plural(unit: string, amount: number) {
    if (amount === 0 || amount > 1) {
        return unit + "s";
    } else return unit;
}
